import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isAuthenticated()) return true;

    // Carga fresh de la app o tras F5 — puede haber refresh cookie viva
    const refreshed = await auth.refresh();
    if (refreshed) return true;

    router.navigate(['/auth/login']);
    return false;
};
